<template>
  <div class="container-fluid">
    <div class="text-center my-2">
      <b-button
        variant="info"
        @click="getPreviousAreaData"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      >
        <feather-icon icon="RefreshCwIcon" class="mr-25" />
        <span>Get Previous Area Data</span>
      </b-button>
    </div>
    <b-card-text>
      <div class="row">
        <div class="col-12 col-lg-6 mb-1">
          <label for="envetdate">Event date</label>
          <b-form-datepicker
            id="envetdate"
            v-model="info.event_date"
            class="mb-1"
          />
        </div>
        <div class="col-12 col-lg-6 mb-1">
          <label for="foodlist">Food Item Name</label>
          <input
            class="form-control"
            placeholder="Food Item Name"
            list="food-list"
            type="foodlist"
            v-model="info.item"
            required
          />
          <datalist id="food-list">
            <option value="Plain Rice with Vegetables & Egg"></option>
            <option value="Egg Khichuri"></option>
            <option value="Chicken Biriyani"></option>
            <option value="Plain Rice with Vegetables & Fish"></option>
          </datalist>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12 mb-1">
          <div class="input-group input-group-merge">
            <div class="input-group-prepend">
              <div class="input-group-text">Total Meal</div>
            </div>
            <input
              class="form-control"
              placeholder="0"
              type="number"
              :value="totalMeal"
              readonly
            />
            <div class="input-group-append">
              <div class="input-group-text">Packet</div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </b-card-text>
    <!-- start multiple field  -->
    <div>
      <div>
        <b-form
          ref="form"
          :style="{ height: trHeight }"
          class="repeater-form"
          @submit.prevent="repeateAgain"
        >
          <!-- Row Loop -->
          <b-row
            v-for="(item, index) in info.items"
            :id="item.id"
            :key="item.id"
            ref="row"
          >
            <!-- Item Name -->
            <b-col md="4">
              <b-form-group
                label="Distribution Area"
                :label-for="'area' + index"
              >
                <b-form-input
                  :id="'area' + index"
                  type="text"
                  list="area-lists"
                  placeholder="Distribution area Name"
                  v-model="info.items[index].area"
                />
                <datalist id="area-lists">
                  <option value="Satrasta"></option>
                  <option value="Karwan Bazar"></option>
                  <option value="Banani Korail Slum"></option>
                  <option value="Mirpur 2"></option>
                  <option value="Kamalapur"></option>
                  <option value="Khilgaon"></option>
                  <option value="Mohammadpur"></option>
                  <option value="Rabindra Sarobar"></option>
                  <option value="Sadarghat"></option>
                  <option value="Wari"></option>
                  <option value="Kadamtala Basabo"></option>
                  <option value="Kajir Dewri, CTG"></option>
                  <option value="Chawkbazar, CTG"></option>
                  <option value="Chilmari, Kurigram"></option>
                </datalist>
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group
                label="Distribution Menu"
                :label-for="'menu' + index"
              >
                <b-form-input
                  :id="'menu' + index"
                  type="text"
                  list="foods-lists"
                  placeholder="Distribution Item Name"
                  v-model="info.items[index].item"
                />
                <datalist id="foods-lists">
                  <option value="Plain Rice with Vegetables & Egg"></option>
                  <option value="Egg Khichuri"></option>
                  <option value="Chicken Biriyani"></option>
                  <option value="Plain Rice with Vegetables & Fish"></option>
                </datalist>
              </b-form-group>
            </b-col>

            <!-- Quantity -->
            <b-col md="2">
              <b-form-group label="Meal" :label-for="'quantity' + index">
                <b-form-input
                  :id="'quantity' + index"
                  type="number"
                  placeholder="0"
                  v-model="info.items[index].packet"
                  @input="updateTotalMeal"
                />
              </b-form-group>
            </b-col>

            <!-- Remove Button -->
            <b-col lg="2" md="3" class="mb-2 mb-md-0">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2"
                @click="removeItem(index)"
              >
                <feather-icon icon="XIcon" class="mr-25" />
                <span>Delete</span>
              </b-button>
            </b-col>
            <b-col cols="12">
              <hr />
            </b-col>
          </b-row>
        </b-form>
      </div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="repeateAgain"
      >
        <feather-icon icon="PlusIcon" class="mr-25" />
        <span>Add New Area</span>
      </b-button>
    </div>
    <div class="text-center mt-5">
      <b-button variant="success" @click="postdata">
        <feather-icon icon="SendIcon" class="mr-25" />
        <span>Submit</span>
      </b-button>
    </div>
 
    <div class="container-fluid mt-5 text-center">
      <div class="table-responsive">
        <table class="table table-bordered table-striped" style="min-width: 600px;">
          <tbody>
            <tr>
              <th>Event Date</th>
              <th>Food Item</th>
              <th>Total Meal</th>
              <th>Crated by</th>
            </tr>
            <tr>
              <td>{{ res.event_date || "N/A" }}</td>
              <td>{{ res.item || "N/A" }}</td>
              <td>{{ res.total_packet || "N/A" }}</td>
              <td>{{ res.created_by || "N/A" }}</td>
            </tr>
          </tbody>
          <tbody v-if="res.area">
            <tr>
              <th>Distribution Area</th>
              <th>Meal</th>
              <th>Item's Name</th>
            </tr>
            <tr v-for="(data, index) in res.area" :key="index">
              <td>{{ data.area }}</td>
              <td>{{ data.packet }}</td>
              <td>{{data.item}}</td>
              <td>--</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { heightFade } from "@core/directives/animations";
import { heightTransition } from "@core/mixins/ui/transition";
import axios from "axios";
import {
  BAlert,
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BCardHeader,
  BCardText,
  BCardTitle,
  BCol,
  BForm,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormSpinbutton,
  BMedia,
  BMediaAside,
  BMediaBody,
  BModal,
  BOverlay,
  BProgress,
  BRow,
  BTable,
  VBModal,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";

export default {
  name: "addfood",
  components: {
    BTable,
    BProgress,
    BBadge,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BFormDatepicker,
    vSelect,
    // PersonalDesh,
    BButton,
    BModal,
    VBModal,
    BForm,
    BFormInput,
    BFormGroup,
    BFormSpinbutton,
    BFormCheckbox,
    BFormSelect,
    BAlert,
    BOverlay,
  },
  directives: {
    "height-fade": heightFade,
    "b-modal": VBModal,
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      res: "",
      info: {
        info_id: "new",
        event_date: null,
        item: "",
        total_packet: "",
        items: [{ id: 1 }],
      },
      nextTodoId: 2,
    };
  },
  computed: {
    totalMeal() {
      // Sum all packets in info.items, treating empty/NaN as 0
      return this.info.items.reduce((sum, item) => {
        let val = parseInt(item.packet, 10);
        return sum + (isNaN(val) ? 0 : val);
      }, 0);
    },
  },
  watch: {
    totalMeal(newVal) {
      // Keep info.total_packet in sync for backend compatibility
      this.info.total_packet = newVal;
    },
    // Also update if items array changes (add/remove)
    'info.items': {
      handler() {
        this.info.total_packet = this.totalMeal;
      },
      deep: true,
    },
  },
  mounted() {
    this.initTrHeight();
    // Ensure total_packet is correct on mount
    this.info.total_packet = this.totalMeal;
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
    this.getlust();
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    getPreviousAreaData() {
      // Check if res.area exists and is an array
      if (this.res && Array.isArray(this.res.area)) {
        // Map res.area to info.items, preserving id if possible
        this.info.items = this.res.area.map((area, idx) => {
          return {
            id: idx + 1,
            ...area
          };
        });
        // Update nextTodoId to avoid id collision if adding new items later
        this.nextTodoId = this.info.items.length + 1;
        // Ensure DOM is updated and scroll/overflow is handled
        this.$nextTick(() => {
          this.initTrHeight();
          this.scrollToForm();
          // Update total_packet after loading previous data
          this.info.total_packet = this.totalMeal;
        });
      } else {
        // If no area data, reset items to default
        this.info.items = [{ id: 1 }];
        this.nextTodoId = 2;
        this.$nextTick(() => {
          this.initTrHeight();
          this.info.total_packet = this.totalMeal;
        });
      }
    },
    getlust() {
      // this.loder = true;
      this.$http
        .post(`/v1/fms/foodmanagement/lust/`)
        .then((response) => {
          this.res = response.data[0];
          // Ensure DOM is updated and scroll/overflow is handled
          this.$nextTick(() => {
            this.initTrHeight();
            this.info.total_packet = this.totalMeal;
          });
          // this.loder = false;
        })
        .catch((error) => {
          console.log(error);
          // this.loder = false;
        });
    },
    reset() {
      this.getlust();
      this.info = {
        info_id: "new",
        event_date: "",
        item: "",
        total_packet: "",
        items: [{ id: 1 }],
      };
      this.$nextTick(() => {
        this.initTrHeight();
        this.info.total_packet = this.totalMeal;
      });
    },
    postdata() {
      const that = this;
      var userdata = JSON.parse(localStorage.getItem("userData"));
      that.info.created_by = userdata.username;
      // Ensure total_packet is up to date before submit
      that.info.total_packet = this.totalMeal;
      if (
        that.info &&
        that.info.event_date &&
        that.info.total_packet &&
        that.info.item
      ) {
        if (that.info.items) {
          this.$swal({
            title: "Are you sure?",
            text: "Yes, Submit this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, submit it!",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
            showLoaderOnConfirm: true,
            preConfirm() {
              that.$http
                .post(`/v1/fms/foodmanagement/post/`, that.info)
                .then((response) => {
                  console.log(response);
                  that.result = response.data;
                  that.gettran && that.gettran();
                  // After update, ensure DOM is correct
                  that.$nextTick(() => {
                    that.initTrHeight();
                  });
                })
                .catch((error) => {
                  // this.$swal.showValidationMessage(`Request failed:  ${error}`);
                  console.log(error);
                });
            },
          }).then((result) => {
            if (result.value) {
              this.$swal({
                icon: "success",
                title: "Created!",
                text: "Data has been Created.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              that.reset();
            }
          });
        } else {
          let variant = "danger";
          this.$bvToast.toast("Area is Required", {
            title: `Error`,
            variant,
            solid: true,
          });
        }
      } else {
        let variant = "danger";
        this.$bvToast.toast("All Fields is Required", {
          title: `Error`,
          variant,
          solid: true,
        });
      }
    },
    repeateAgain() {
      this.info.items.push({
        id: (this.nextTodoId += this.nextTodoId),
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        this.scrollToForm();
        this.info.total_packet = this.totalMeal;
      });
    },
    removeItem(index) {
      this.info.items.splice(index, 1);
      this.$nextTick(() => {
        if (this.$refs.row && this.$refs.row[0]) {
          this.trTrimHeight(this.$refs.row[0].offsetHeight);
        }
        this.info.total_packet = this.totalMeal;
      });
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.trSetHeight(this.$refs.form.scrollHeight);
        }
        this.info.total_packet = this.totalMeal;
      });
    },
    scrollToForm() {
      // Scroll to the form if overflow occurs, to keep UI in view
      this.$nextTick(() => {
        const form = this.$refs.form;
        if (form && form.scrollIntoView) {
          form.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
      });
    },
    updateTotalMeal() {
      // This method is called on input for packet fields, but actual update is handled by computed/watch
      // This is a placeholder in case you want to trigger any side effects
      // No-op
    },
  },
};
</script>
<style>
/* Removed all custom styles as per instruction */
</style>
